import React, { useEffect, useState } from "react";
import Alert from "./Alert";

export default function GlobalSessionHandler() {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const handleSessionExpired = () => {
      setShowPopup(true);
      sessionStorage.clear(); // Clear token immediately
    };
    
    window.addEventListener("sessionExpired", handleSessionExpired);
    return () => window.removeEventListener("sessionExpired", handleSessionExpired);
  }, []);

//   console

  const handleOk = () => {
    sessionStorage.clear();
    window.location.href = "/";
  };

  return (
    <Alert
      openPopup={showPopup}
      title="Session Timed-out!"
      message="Login again to continue"
      textBox={false}
      alertOk={handleOk}
      cancel={false}
      handleClose={() => setShowPopup(false)}
    />
  );
}